import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";

export interface IExportTemplate {
  columns: Array<string>;
  id: number;
  name: string;
  area: string;
}

@Injectable({
  providedIn: "root"
})
export class ExportExcelService {
  labels: BehaviorSubject<any> = new BehaviorSubject({});
  dataForExport: BehaviorSubject<any> = new BehaviorSubject([]);
  fileName: BehaviorSubject<string> = new BehaviorSubject("");
  area: BehaviorSubject<string> = new BehaviorSubject("");

  constructor(private _http: HttpClient) {
  }

  getTemplates() {
    return this._http.get<Array<IExportTemplate>>("/export-template");
  }

  getTemplate(name: string) {
    return this._http.get<Array<IExportTemplate>>(`/export-template/${name}`);
  }

  updateTemplate(name: string, columns: Array<string>) {
    return this._http.put<Array<IExportTemplate>>(`/export-template/${name}`, { columns });
  }

  deleteTemplate(name: string) {
    return this._http.delete<Array<IExportTemplate>>(`/export-template/${name}`);
  }

  saveTemplate(name: string, columns: Array<string>, area: string) {
    return this._http.post("/export-template", { name, columns, area })
      .pipe((res: any) => {
        return res;
      });
  }
}
